import { type IGeoreference } from "@interfaces/common/IGeoreference";
import { type ISettings } from "@interfaces/common/ISettings";
import { type ITypeState } from "@interfaces/common/ITypeState";

export class SetTypeState {
  static readonly type = "[Common] Set Type State";
  constructor(public typeStates: ITypeState[]) {}
}

export class SetSettings {
  static readonly type = "[Common] Set Settings";
  constructor(public settings: ISettings) {}
}

export class SetCurrentTenant {
  static readonly type = "[Common] Set Current Tenant";
  constructor(public currentTenant: string) {}
}

export class SetSavedRut {
  static readonly type = "[Common] Set Saved Rut";
  constructor(public rut: string) {}
}

export class ClearSavedRut {
  static readonly type = "[Common] Clear Saved Rut";
}

export class SetCurrentTenantBusinessName {
  static readonly type = "[Common] Set Current Tenant Business Name";
  constructor(public businessName: string) {}
}

export class SetAccessibleModules {
  static readonly type = "[Common] Set Accessible Modules";
  constructor(public tenant?: string) {}
}

export class ClearAccessibleModules {
  static readonly type = "[Common] Clear Accessible Modules";
}

export class SetCompanyGeoreference {
  static readonly type = "[Common] Set Company Georeference";
  constructor(public companyGeoreference: IGeoreference) {}
}

export class ClearCompanyGeoreference {
  static readonly type = "[Common] Clear Company Georeference";
}
